module.exports = __webpack_public_path__ + "static/img/logo.1c1a3235.png";